import classNames from "classnames";
import * as React from "react";
import { ReactElement, useEffect } from "react";
import { closeMenu, openMenu, Wrapper } from "react-aria-menubutton";

import { NavigationTogglePanelAssets } from "./navigation-panel/navigation-toggle-panel-content/NavigationTogglePanelAssets";
import { NavigationTogglePanelReports } from "./navigation-panel/navigation-toggle-panel-content/NavigationTogglePanelReports";
import style from "./navigation-toggle-panel.scss";
import { NavigationMenuItem } from "components/navigation/navigation-menu-item/NavigationMenuItem";

interface Props {
    title: string;
    isOpen: boolean;
    id: string;
    openId?: string;
    closeId?: string;
    children: ReactElement;
    className?: string;
    toggleButtonTestId?: string;
    panelType?: "reports" | "assets";
    isAssetFolder?: boolean;
    hasChildren?: boolean;
    path: string;
    isArchived?: boolean;
    isFolderKebabOpened: (isOpen: boolean) => void;
}

export const NavigationTogglePanel = (props: Props) => {
    const [isItemExpanded, setIsItemExpanded] = React.useState(props.isOpen);
    const openClass: string = isItemExpanded ? style.activeLeftTitle : style.leftTitle;
    const chevronClass: string = classNames(style.arrow, { [style.down]: isItemExpanded });

    useEffect(() => {
        if (props.openId !== undefined) {
            openMenu(props.openId);
        }
        if (props.closeId !== undefined) {
            closeMenu(props.closeId);
        }
    }, []);

    return (
        <Wrapper
            id={props.id}
            className={classNames(openClass, props.className)}
            onMenuToggle={(state) => {
                setIsItemExpanded(state.isOpen);
            }}
            closeOnSelection={false}
            closeOnBlur={false}
            data-testid={props.toggleButtonTestId}
        >
            {props.panelType === "reports" ? (
                <NavigationTogglePanelReports
                    title={props.title}
                    chevronClass={chevronClass}
                    hasChildren={props.hasChildren}
                />
            ) : props.panelType === "assets" ? (
                <NavigationTogglePanelAssets
                    isKebabOpened={props.isFolderKebabOpened}
                    title={props.title}
                    path={props.path}
                    isAssetFolder={props.isAssetFolder}
                    isArchived={props.isArchived}
                    hasChildren={props.hasChildren}
                    isFolderExpanded={isItemExpanded}
                    chevronClass={chevronClass}
                />
            ) : (
                <NavigationMenuItem testId={props.toggleButtonTestId} as="button" isActive={isItemExpanded}>
                    <span>{props.title}</span>
                </NavigationMenuItem>
            )}
            {props.children}
        </Wrapper>
    );
};
